exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tat-dashboard-container{padding:15px}.gap-1{gap:.25rem}.badge-sm{font-size:.6rem;padding:.2rem .4rem}.b-table,.b-table *,.b-table td,.b-table th,.badge,.badge-sm,.font-weight-bold,.text-muted,h6,small{font-size:.625rem!important}.b-table td{vertical-align:top;padding:.5rem!important}.badge-secondary{background-color:#6c757d!important;color:#fff!important}.badge-light{background-color:#f8f9fa!important;color:#495057!important;border:1px solid #dee2e6}.mainCardBG{background-color:#fff;border:1px solid #e3e6f0}.formCard{background-color:#4e73df!important}.text-wrap{word-wrap:break-word;white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f786c3e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/reports/ffExportBillingReport.vue
// module id = 1735
// module chunks = 0